import {HTTP} from "./util"




const CountriesWrapper = {

    init: (config) => {
        const cache = {
            loaded: false,
            countries: [],
        };

        return {

            Get: () => {

                if (cache.loaded) {
                    return new Promise((r) => {
                        r(cache.countries)
                    });
                }
                else {
                    return new Promise((resolve, reject) => {
                        HTTP.get(`${config.url}/freight-master-data/countries?page=0&size=1000&sort=asc`)
                            .then((response) => {
                                if (response.ok)
                                    return response.json();
                                else {
                                    return {
                                        '_embedded': {
                                            'countries': [
                                                {code: "AU" , name : "Australia"}
                                            ]
                                        }
                                    }
                                }
                            })
                            .then((countries) => {
                                cache.countries = countries['_embedded']['countries'].map((e) => {
                                    return {value: e.code, label: e.name}
                                });
                                resolve(cache.countries);
                                cache.loaded = true;
                            });
                    });
                }
            }


        }
    }

};

const Countries = (config) => {
    return CountriesWrapper.init(config);
};

export {

    Countries

}